"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Data transfer object for creating new binds of paired products
 *
 * @author RV
 */


var CompetitorProductBindDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CompetitorProductBindDTO, _DomainObject_1$Domai);

  /**
   *
   * @param id of competitor product
   * @param ratio from {@link CompetitorProductBinding}
   * @param charger from {@link CompetitorProductBinding}
   */
  function CompetitorProductBindDTO(id, ratio, charger) {
    var _this;

    _classCallCheck(this, CompetitorProductBindDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProductBindDTO).call(this));
    _this.id = id;
    _this.ratio = ratio;
    _this.charger = charger;
    return _this;
  }

  return CompetitorProductBindDTO;
}(DomainObject_1.DomainObject);

exports.CompetitorProductBindDTO = CompetitorProductBindDTO; // tslint:disable-next-line:member-ordering

CompetitorProductBindDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CompetitorProductBindDTO.name);
  return {
    id: builder.id('id'),
    ratio: builder.bigNum('ratio'),
    charger: builder.bigNum('charger')
  };
}();